




























































































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { Photos } from './Photos';
import { mapGetters } from 'vuex';
import { SearchPayload, PhotoPayload } from '@/Stores/AppealStore';
import Vue from 'vue';
import constants from '@/constants';
import fileSaver from 'file-saver';
import VatsAPI from '@/Shared/VatsAPI';
import { SearchParams } from './Citation/SearchParams';

export default mixins(LocationBasedMixin).extend({
    data() {
        return {
            i18nPrefix: 'appeals.showPhotos',
            rotation: 0,
            zoom: {
                width: 0,
                height: 0
            },
            selectImgSize: {
                width: 0,
                height: 0,
                originalW: 0,
                originalH: 0
            },
            selectedImg: {},
            modalShow: false
        };
    },
    computed: {
        ...mapGetters('appealModule', [
            'getPhotos',
            'searchError',
            'searchParams',
            'getSearchResults',
            'searchInProgress',
            'photosLoaded'
        ])
    },
    mounted() {
        this.$root.$on('bv::modal::hide', (bvEvent: any, modalId: any) => {
            this.$data.rotation = 0;
            this.$data.zoom.width = 0;
            this.$data.zoom.height = 0;
            this.$data.selectImgSize.width = 0;
            this.$data.selectImgSize.height = 0;
            this.$data.selectImgSize.originalW = 0;
            this.$data.selectImgSize.originalH = 0;
        });

        this.$root.$on('bv::modal::show', (bvEvent: any, modalId: any) => {
            this.updateImgDimensions();
        });
        if (!this.getSearchResults.citationNumber) {
            return;
        }

        if (this.photosLoaded) {
            return;
        }

        const searchParams = new SearchParams();
        searchParams.citationNumber = this.getSearchResults.citationNumber;
        searchParams.vehicleState = this.getSearchResults.vehicleState;
        searchParams.vehicleLicense = this.getSearchResults.vehicleLicense;

        const payload: SearchPayload = {
                parameters: this.searchParams,
                location: this.$typedStore.state.currentLocation
            };

        this.$typedStore.modules.appealModule.actions.searchPhotos(payload);
    },
    methods: {
        async rotateImg(result: Photos) {
            this.$data.rotation += 90;
            if (this.$data.rotation === 360) {
                this.$data.rotation = 0;
            }

            if (result !== null) {
                this.$data.selectedImg = result;
                if (!this.$data.modalShow) {
                    this.$data.modalShow = true;
                }
            }
            if (this.$data.selectImgSize.width > this.$data.selectImgSize.height) {
                if (Number(this.$data.rotation) === 90 || Number(this.$data.rotation) === 270) {
                    this.$data.selectImgSize.width = this.$data.selectImgSize.originalH;
                    this.$data.selectImgSize.height = this.$data.selectImgSize.originalW;
                }
            }
        },
        async zoomInImg(result: Photos) {
            this.$data.zoom.width += 10;
            this.$data.zoom.height += 10;

            if (result !== null) {
                this.$data.selectedImg = result;
                if (!this.$data.modalShow) {
                    this.$data.modalShow = true;
                }
            }
        },
        zoomOutImg(result: Photos) {
            if (result !== null) {
                this.$data.selectedImg = result;
                if (!this.$data.modalShow) {
                    this.$data.modalShow = true;
                }
            }

            this.$data.zoom.width -= 10;
            this.$data.zoom.height -= 10;
        },
        saveImg(result: Photos) {
            if (result !== null) {
                this.$data.selectedImg = result;
            }
            const byteCharacters = atob(this.$data.selectedImg.img64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], {type: 'image/png'});
            fileSaver.saveAs(blob, 'image.png');
        },
        async updateImgDimensions() {
            const img = new Image();
            img.onload = () => {
                this.$data.selectImgSize.width = img.width;
                this.$data.selectImgSize.height = img.height;
                this.$data.selectImgSize.originalW = img.width;
                this.$data.selectImgSize.originalH = img.height;

                if (this.$data.selectImgSize.width > this.$data.selectImgSize.height) {
                    if (Number(this.$data.rotation) === 90 || Number(this.$data.rotation) === 270) {
                        this.$data.selectImgSize.width = this.$data.selectImgSize.originalH;
                        this.$data.selectImgSize.height = this.$data.selectImgSize.originalW;
                    }
                }
            };
            img.src = 'data:image/png;base64,' + this.$data.selectedImg.img64String;
        },
        async printImg(result: Photos) {
            if (result == null) {
                result = this.$data.selectedImg;
            }

            const response = (await VatsAPI.post<Blob>(`/${this.$typedStore.state.currentLocation.urlSegment}/citations/photopdf`,
            {
                imageServerID: result.citationPhoto.imageServerID,
                recID: result.citationPhoto.recID,
                citationID: result.citationPhoto.citationID
             },
            {
                headers: {
                    accept: constants.OctetMimeType
                },
                responseType: 'blob'
            }));

            fileSaver.saveAs(response.data, 'image.pdf');
        },
        async deleteImg(result: Photos, index: number) {
            if (result !== null) {
                this.$data.selectedImg = {};
            }

            Vue.delete(this.getPhotos, index);

            const payload: PhotoPayload = {
                photos: this.getPhotos,
                item: result,
                location: this.$typedStore.state.currentLocation
            };

            this.$typedStore.modules.appealModule.actions.deletePhoto(payload);
        },
        async moveToTop(item: Photos) {
            const tempList = [];
            tempList.push(item);

            const lfiltered = this.getPhotos;
            for (const fItem of lfiltered) {
                if (Number(fItem.citationPhoto.recID) !== Number(item.citationPhoto.recID)) {
                    tempList.push(fItem);
                }
            }

            this.$typedStore.modules.appealModule.mutations.setPhotos({
                results: tempList,
                location: this.$typedStore.state.currentLocation
            });
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'imageFullView');
        }
    }
});
